var app = angular.module('tapSplitView');

app.factory('viewStack', function() {
    var self = {};
    self.viewStack = [];
    self.viewIndex = -1;
    self.previousView = null;

    self.preparePage = function($page) {
        $page.css('left', $page.outerWidth());
    }

    self.positionPages = function() {
        var width = null;

        for (var i = self.viewStack.length - 1; i >= 0; i--) {
            var $page = $(self.viewStack[i]);
            if (!width) {
                width = $page.outerWidth();
            }
            var multiplier = i - self.viewIndex;

            $page.css('left', multiplier * width);
        };

        self.positionNonViewStackPages();
    }

    self.positionNonViewStackPages = function() {
        var width = null;

        $('.dv-page').each(function(){
            if ($(this).hasClass('dont-position')) return;

            if (self.viewStack.indexOf('#' + $(this).attr('id')) == -1) {
                if (!width) {
                    width = $(this).actual('outerWidth');
                }

                $(this).css('left', width);
            }
        })
    }

    self.animateOut = function($page, reverse) {
        var left = (reverse) ? +$page.outerWidth() : -$page.outerWidth();
        $page.animate({left: left}, 500, 'swing');
    }

    self.animateIn = function($page) {
        var curHeight = self.getPreviousView()[0].scrollHeight;
        var pageHeight = $page[0].scrollHeight;

        if (curHeight > pageHeight) {
            $page.css('height', curHeight);
        }

        $page.animate({left: 0}, 500, 'swing', function(){
            $('.dv-page-holder').animate({scrollTop: 0}, function(){
                $page.css('height', pageHeight);
            });
        });
    }

    self.appearIn = function($page) {
        $page.css('left', 0);
    }

    self.getPreviousView = function() {
        return this.previousView;
    }

    self.getCurrentView = function() {
        return $(self.viewStack[self.viewIndex]);
    }

    $(window).on('resize', function(){
        self.positionPages();
    })

    return {
        getViewIndex: function() {
            return self.viewIndex;
        },
        addToStack: function(selector) {
            self.viewStack.push(selector);
        },
        prepare: function(selector) {
            self.preparePage($(selector));
        },
        pushView: function (selector, options) {
            if (self.viewIndex >= 0) {
                self.viewStack.push(selector);
                self.previousView = self.getCurrentView();
                self.animateOut(self.previousView);
            } else {
                self.positionPages();
            }

            self.viewIndex++;

            if (options && options.hasOwnProperty('animated') && !options.animated) {
                self.appearIn(self.getCurrentView());
            } else {
                self.animateIn(self.getCurrentView());
            }

            setTimeout(self.positionNonViewStackPages, 100);
        },
        popView: function (url) {
            self.previousView = self.getCurrentView();
            self.animateOut(self.previousView, true);
            self.viewIndex--;
            self.animateIn(self.getCurrentView());

            self.viewStack.pop(self.viewIndex);
        },
        positionPages: function(){
            self.positionPages();
        },
        positionNonViewStackPages: function(){
            self.positionNonViewStackPages();
        },
        isEmpty: function() {
            return self.viewStack.length === 0;
        },
        reset: function() {
            for (var i = self.viewStack.length - 1; i > 0; i--) {
                self.preparePage($(self.viewStack[i]));
                self.viewStack.pop(i);
            };
            self.viewIndex = -1;
        },
        getCurrentViewTitle: function() {
            return self.getCurrentView().attr('title');
        },
    };
});
